import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const assignPriceBookItems = createAsyncThunk("assignPriceBookItems", async ({ id, values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`pricebook/${id}/items`, values);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RewardPriceBookItemAssignSlice = createSlice({
	name: "RewardPriceBookItemAssignSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(assignPriceBookItems.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(assignPriceBookItems.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(assignPriceBookItems.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default RewardPriceBookItemAssignSlice.reducer;
